export const securityConfig = {
  // Session inactivity timeout (minutes)
  inactivityTimeoutMinutes: 60,

  // If true, fingerprint mismatches will sign the user out; if false, just log
  enforceFingerprint: false,

  // Sign-in rate limiting
  signInRateLimit: {
    maxAttempts: 10,
    windowMs: 15 * 60 * 1000,
  },
} as const;
